import type { TemplateWithoutSections } from 'src/data-capture/hooks/templates/useTemplates';
import { TemplateRow } from './TemplateRow';
import { SelectableList } from 'src/UI/generate-flow/SelectableList';

type TemplateListProps = {
  items: TemplateWithoutSections[];
  selectedTemplateId?: string;
  onSelect: (template: TemplateWithoutSections) => void;
};

export function TemplateList({ items, selectedTemplateId, onSelect }: TemplateListProps) {
  return (
    <SelectableList
      items={items}
      getKey={t => t.id}
      renderRow={template => (
        <TemplateRow
          template={template}
          selected={template.id === selectedTemplateId}
          onSelect={onSelect}
        />
      )}
    />
  );
}
